import {DrawerLink} from "./drawer-link";

const FIXED_DRAWER_LINKS: {[groupKey: string]: DrawerLink[]} = {
	Top: [
		new DrawerLink({
			uid: "fixed-assistant",
			Icon: "fa:comments",
			Name: "Assistent",
			Title: "Assistent",
			Url: "https://assistent.winfakt.tools/",
			DevOnly: true
		})
	]
};

export function getFixedDrawerLinksForGroup(groupKey: string): DrawerLink[] {
	return FIXED_DRAWER_LINKS[groupKey] || [];
}

export function findFixedDrawerLinkByUid(uid: string): DrawerLink | undefined {
	for (let links of Object.values(FIXED_DRAWER_LINKS)) {
		let found = links.find(l => l.uid === uid);
		if (found) {
			return found;
		}
	}
	return undefined;
}
